<template>
  <a-loading :loading="integrationGameMeta.loading">
    <l-rows>
      <m-header
        v-if="integrationGame.game"
        :title-text="`${integrationGame.game.name} ${integrationGame.gameVersion.version}`"
        :subtitle-text="`${integrationGame.integration.name}`"
      />
      <a-box v-if="integrationGame.active">
        <o-form
          :title="$t('integrations.deactivateGameTitle')"
          :subtitle="$t('integrations.deactivateGameDescription')"
          :submit-text="$t('common.deactivate')"
          submit-variant="danger"
          @submit="handleDeactivate"
        />
      </a-box>
      <a-box v-else>
        <o-form
          :title="$t('integrations.activateGameTitle')"
          :subtitle="$t('integrations.activateGameDescription')"
          :submit-text="$t('common.activate')"
          submit-variant="success"
          @submit="handleActivate"
        />
      </a-box>
    </l-rows>
  </a-loading>
</template>

<script>
  import { useActivateIntegrationGame, useIntegrationGame, useDeactivateIntegrationGame } from '@/views/integrations/integrationHooks'
  import { ABox, ALoading, LRows, MHeader, OForm } from 'codefabrik-gui-vue'

  export default {
    name: 'IntegrationGame',
    components: { ABox, ALoading, MHeader, LRows, OForm },
    mixins: [
      useIntegrationGame('integrationGame'),
      useDeactivateIntegrationGame('handleDeactivate'),
      useActivateIntegrationGame('handleActivate')
    ],
  }
</script>

<style scoped>

</style>
